import React, { createContext, useContext, useState } from 'react'

interface PolicyContextType {
  isPolicyAccepted: boolean
  acceptPolicy: () => void
}

const PolicyContext = createContext<PolicyContextType>({
  isPolicyAccepted: false,
  acceptPolicy: () => {},
})

export function PolicyProvider({ children }: { children: React.ReactNode }) {
  const [isPolicyAccepted, setIsPolicyAccepted] = useState(false)

  const acceptPolicy = () => setIsPolicyAccepted(true)

  return (
    <PolicyContext.Provider value={{ isPolicyAccepted, acceptPolicy }}>
      {children}
    </PolicyContext.Provider>
  )
}

export function usePolicyContext() {
  return useContext(PolicyContext)
}
